<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <div class="row">
            <div class="col-lg-12">
                <h3>Step 1: Upload Documents</h3>
            </div>
            <div class="col-lg-8">
                <div class="row form-options">
                    <div class="col-lg-6">
                        <identity-type
                            :data-segment-id="dataSegmentId"
                            :disabled="false"
                        ></identity-type>
                    </div>
                    <div class="col-lg-6">
                        <identity-document></identity-document>
                    </div>
                    <div class="col-lg-6">
                        <utility-bill></utility-bill>
                    </div>
                    <div class="col-lg-6"></div>
                    <div class="col-lg-6">
                        <base-button
                            btn-type="submit"
                            btn-variant="primary"
                            btn-label="CONTINUE"
                            :class="loading ? 'disabled' : ''"
                            :disabled="loading"
                        ></base-button>
                    </div>
                </div>
            </div>
            <div class="col-lg-4"></div>
        </div>
    </b-form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import request from '@/utils/request'
import _ from 'lodash'

import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocument from '@/components/registration/IdentityDocument.vue'
import UtilityBill from '@/components/registration/UtilityBill.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        IdentityType,
        IdentityDocument,
        UtilityBill,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            userOcr: (state) => state.registration.useOcr,
        }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        // dataSegmentId() {
        //     if (this.$route.params.dataSegmentId) {
        //         return this.$route.params.dataSegmentId
        //     }
        //     return this.$store.getters.dataSegmentId
        // },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */

    watch: {
        /**
         * Handle when the file is uploaded successfully
         *
         * @return {void}
         */
        async 'form.documentInfo.identity.fileName'(value) {
            // check if the value is not empty
            // and perform action accordintly
            if (this.userOcr && value !== null && value !== undefined) {
                try {
                    const formData = new FormData()
                    formData.append(
                        'filePath',
                        `${process.env.VUE_APP_API_URL}files/customers/${value}`
                    )
                    formData.append('type', 'id')

                    const headers = {
                        'Content-Type': 'multipart/form-data',
                    }
                    const { data } = await request.post('ocr/', formData, {
                        headers,
                    })

                    if (
                        ['upload-document', 'record-video'].includes(
                            this.$route.name.toString()
                        )
                    ) {
                        this.$store.commit('updateField', {
                            key: 'identityInfo.number',
                            value: data.customer_data.idnumber,
                        })

                        this.$store.commit('updateField', {
                            key: 'identityInfo.expiryDate',
                            value: this.$moment(
                                data.customer_data.dateofexpiry,
                                'D-M-Y'
                            ).isValid()
                                ? this.$moment(
                                      data.customer_data.dateofexpiry,
                                      'D-M-Y'
                                  ).format('YYYY-MM-DD')
                                : '',
                        })

                        let fullName = _.split(data.customer_data.name, ' ')

                        let firstName = fullName.shift()
                        let lastName = fullName.pop()
                        let middleName = fullName.join(' ')

                        this.$store.commit('updateField', {
                            key: 'basicInfo.firstName',
                            value: firstName,
                        })
                        this.$store.commit('updateField', {
                            key: 'basicInfo.middleName',
                            value: middleName,
                        })
                        this.$store.commit('updateField', {
                            key: 'basicInfo.lastName',
                            value: lastName,
                        })
                        this.$store.commit('updateField', {
                            key: 'basicInfo.dateOfBirth',
                            value: this.$moment(
                                data.customer_data.dob,
                                'D-M-Y'
                            ).isValid()
                                ? this.$moment(
                                      data.customer_data.dob,
                                      'D-M-Y'
                                  ).format('YYYY-MM-DD')
                                : '',
                        })
                    }
                } catch (error) {
                    console.log(error)
                }
                this.$store.commit('setLoading', false)
            }
        }, // End of user() method
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.$store.commit('initDefaultFields', 'form')
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // validate the form fields
            const result = await this.$validator.validateAll()
            // Check if validation fails
            if (result) {
                // this.$store.commit('setLoading', true)

                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'public-registration-setup-profile',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    this.$router.push('/register-customer/setup-profile')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
    }, // End of Component > mounted
} // End of export default
</script>
